import { Collections } from '../../firebase/firestore/collections';
import { VideoRooms } from '../../firebase/firestore/documents/videoRooms';
import { useDocumentSnapshot } from '../../firebase/firestore/hooks';

const useInterviewRoomInformation = (roomId: string | undefined): VideoRooms | undefined => {
  return useDocumentSnapshot<VideoRooms>(Collections.VIDEO_ROOMS, roomId);
};

export default useInterviewRoomInformation;
